// @flow
export {
  getProductsMainPath,
  getComparisonPath,
  getHomePath,
  getCategoriesPath,
  getCategoryPath,
  getManagementCompanyPath,
  getManagementCompaniesPath,
  getSheetPath
} from './paths';

export {
  getHomeCanonical,
  getCompanyCanonical,
  getManagementCompaniesCanonical,
  getCategoriesCanonical,
  getItemListSchemaORG,
  getBreadcrumbSchemaORG
} from './canonicals';

export { shuffle } from './shuffle';
export { loginAction } from './loginAction';
export { sendLogError } from './sendLogError';
